<template>
  <div>
    <h4 class="my-4">{{$tc('Labels.Device',2)}}</h4>
    <div class="flex" >
      <div class="flex-1 p-4">
        <statistics
          icon="CpuIcon"
          statistic="3k"
          statisticTitle="Dispositivos Activos"
          color="success"
        />
      </div>
      <div class="flex-1 p-4">
        <statistics
          icon="CpuIcon"
          statistic="100"
          statisticTitle="Dispositivos Inactivos"
          color="danger"
        />
      </div>
      <div class="flex-1 p-4">
        <statistics
          icon="CpuIcon"
          statistic="2k"
          statisticTitle="Dispositivos En Bodega"
          color="warning"
        />
      </div>
    </div>
    <h4 class="my-4">{{$t('Labels.Licenses',)}}</h4>
    <div class="flex" >
      <div class="flex-1 p-4">
        <statistics
          icon="KeyIcon"
          statistic="3k"
          statisticTitle="Licencias Activas"
          color="success"
        />
      </div>
      <div class="flex-1 p-4">
        <statistics
          icon="KeyIcon"
          statistic="100"
          statisticTitle="Licencias Inactivas"
          color="danger"
        />
      </div>
      <div class="flex-1 p-4">
        <statistics
          icon="KeyIcon"
          statistic="2k"
          statisticTitle="Licencias próximas a expirar"
          color="warning"
        />
      </div>
    </div>
    <h4 class="my-4">{{$t('Labels.Companies',)}}</h4>
    <div class="flex" >
      <div class="flex-1 p-4">
         <vx-card class="overflow-hidden container-card">
          <div slot="no-body">
              <div class="p-6 text-center">
                  <vs-avatar :src="'data:image/jpeg;base64,'+company.image" size="60px" />
                  <div class="truncate">
                      <h2 class="mb-1 font-bold">{{ company.name }}</h2>
                  </div>
              </div>
          </div>
        </vx-card>
      </div>
      <div class="flex-1 p-4">
        <statistics
          icon="KeyIcon"
          statistic="100"
          statisticTitle="Licencias"
          color="primary"
        />
      </div>
      <div class="flex-1 p-4">
        <statistics
          icon="CpuIcon"
          statistic="2k"
          statisticTitle="Dispositivos"
          color="primary"
        />
      </div>
    </div>
  </div>
</template>
<script>
import statistics from '@/components/statistics/statistics.vue'
import {request} from '@/request.js'
export default {
  components: {
    statistics
  },
  data () {
    return {
      company: []
    }
  },
  methods: {
    async getResponse () {
      const params = {
        url: 'companies/4566f6b0-bb98-4192-aec3-ddaddfb5d224',
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.company = response.data.data
      })
    }
  },
  created () {
    this.getResponse()
  }
}
</script>